/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

 /**
 *
 *
 * @export
 * @interface PlaceDto
 */
export interface PlaceDto {

    /**
     * Unique identifier
     *
     * @type {number}
     * @memberof PlaceDto
     * @example 1
     */
    id: number;

    /**
     * Creation timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof PlaceDto
     * @example 2024-01-15T10:30:00.000Z
     */
    created: string;

    /**
     * Last update timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof PlaceDto
     * @example 2024-06-01T08:00:00.000Z
     */
    updated: string;

    /**
     * Soft-delete timestamp — null when the record is active
     *
     * @type {string}
     * @memberof PlaceDto
     */
    deleted: string | null;

    /**
     * @type {string}
     * @memberof PlaceDto
     */
    placeId: string;

    /**
     * @type {string}
     * @memberof PlaceDto
     */
    name?: string;

    /**
     * @type {string}
     * @memberof PlaceDto
     */
    formattedAddress?: string;

    /**
     * @type {string}
     * @memberof PlaceDto
     */
    street?: string;

    /**
     * @type {string}
     * @memberof PlaceDto
     */
    streetNumber?: string;

    /**
     * @type {string}
     * @memberof PlaceDto
     */
    postalCode?: string;

    /**
     * @type {string}
     * @memberof PlaceDto
     */
    city?: string;

    /**
     * @type {string}
     * @memberof PlaceDto
     */
    province?: string;

    /**
     * @type {string}
     * @memberof PlaceDto
     */
    country?: string;

    /**
     * Latitude (WGS84)
     *
     * @type {number}
     * @memberof PlaceDto
     */
    lat: number;

    /**
     * Longitude (WGS84)
     *
     * @type {number}
     * @memberof PlaceDto
     */
    lng: number;

    /**
     * @type {string}
     * @memberof PlaceDto
     */
    note?: string;
}
